import ModalCancelInventory from './ModalCancelInventory'

export default ModalCancelInventory
